import { Reveal, stagger, item } from "./motion";
import { motion } from "framer-motion";
import { EXPERTISE } from "@/data";
import { Scissors, HeartPulse, Check } from "lucide-react";

const Col = ({ title, items, icon: Icon, accent }) => (
  <div className="rounded-3xl border border-black/5 bg-white p-8 sm:p-10">
    <div
      className="w-12 h-12 rounded-2xl flex items-center justify-center mb-6"
      style={{ background: accent + "1A", color: accent }}
    >
      <Icon size={22} />
    </div>
    <h3 className="font-serif-display text-3xl text-[#1A1C1A] mb-6">{title}</h3>
    <motion.ul
      variants={stagger}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true }}
      className="space-y-3.5"
    >
      {items.map((it) => (
        <motion.li key={it} variants={item} className="flex gap-3 text-[#4A4D4A]">
          <Check size={18} className="mt-0.5 shrink-0" style={{ color: accent }} />
          <span>{it}</span>
        </motion.li>
      ))}
    </motion.ul>
  </div>
);

export const Expertise = () => (
  <section id="expertise" className="py-24 sm:py-32 scroll-mt-24" data-testid="expertise">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        <p className="overline text-[#B9735A] mb-5">Clinical Capabilities</p>
        <h2 className="font-serif-display font-light text-4xl sm:text-6xl text-[#1A1C1A] tracking-tight max-w-3xl">
          Advanced surgery, thoughtful <span className="italic text-[#B9735A]">prevention</span>
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <div className="mt-12 grid md:grid-cols-2 gap-5">
          <Col {...EXPERTISE.surgical} icon={Scissors} accent="#B9735A" />
          <Col {...EXPERTISE.prevention} icon={HeartPulse} accent="#6B7A6A" />
        </div>
      </Reveal>
    </div>
  </section>
);
